<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"
		 class="icon-transparent">
		<mask id="mask0_11048_194345" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="44"
			  height="44">
			<circle cx="22" cy="22" r="21.5" fill="white" stroke="#CFD3D8"/>
		</mask>
		<g mask="url(#mask0_11048_194345)">
			<rect x="44" y="6" width="8" height="8" transform="rotate(180 44 6)" fill="#D9D9D9"/>
			<rect x="36" y="6" width="8" height="8" transform="rotate(180 36 6)" fill="white"/>
			<rect x="28" y="6" width="8" height="8" transform="rotate(180 28 6)" fill="#D9D9D9"/>
			<rect x="20" y="6" width="8" height="8" transform="rotate(180 20 6)" fill="white"/>
			<rect x="12" y="6" width="8" height="8" transform="rotate(180 12 6)" fill="#D9D9D9"/>
			<rect x="4" y="6" width="8" height="8" transform="rotate(180 4 6)" fill="white"/>
			<rect x="-4" y="6" width="8" height="8" fill="#D9D9D9"/>
			<rect x="4" y="6" width="8" height="8" fill="white"/>
			<rect x="12" y="6" width="8" height="8" fill="#D9D9D9"/>
			<rect x="20" y="6" width="8" height="8" fill="white"/>
			<rect x="28" y="6" width="8" height="8" fill="#D9D9D9"/>
			<rect x="36" y="6" width="8" height="8" fill="white"/>
			<rect x="44" y="22" width="8" height="8" transform="rotate(180 44 22)" fill="#D9D9D9"/>
			<rect x="36" y="22" width="8" height="8" transform="rotate(180 36 22)" fill="white"/>
			<rect x="28" y="22" width="8" height="8" transform="rotate(180 28 22)" fill="#D9D9D9"/>
			<rect x="20" y="22" width="8" height="8" transform="rotate(180 20 22)" fill="white"/>
			<rect x="12" y="22" width="8" height="8" transform="rotate(180 12 22)" fill="#D9D9D9"/>
			<rect x="4" y="22" width="8" height="8" transform="rotate(180 4 22)" fill="white"/>
			<rect x="-4" y="22" width="8" height="8" fill="#D9D9D9"/>
			<rect x="4" y="22" width="8" height="8" fill="white"/>
			<rect x="12" y="22" width="8" height="8" fill="#D9D9D9"/>
			<rect x="20" y="22" width="8" height="8" fill="white"/>
			<rect x="28" y="22" width="8" height="8" fill="#D9D9D9"/>
			<rect x="36" y="22" width="8" height="8" fill="white"/>
			<rect x="44" y="38" width="8" height="8" transform="rotate(180 44 38)" fill="#D9D9D9"/>
			<rect x="36" y="38" width="8" height="8" transform="rotate(180 36 38)" fill="white"/>
			<rect x="28" y="38" width="8" height="8" transform="rotate(180 28 38)" fill="#D9D9D9"/>
			<rect x="20" y="38" width="8" height="8" transform="rotate(180 20 38)" fill="white"/>
			<rect x="12" y="38" width="8" height="8" transform="rotate(180 12 38)" fill="#D9D9D9"/>
			<rect x="4" y="38" width="8" height="8" transform="rotate(180 4 38)" fill="white"/>
			<rect x="-4" y="38" width="8" height="8" fill="#D9D9D9"/>
			<rect x="4" y="38" width="8" height="8" fill="white"/>
			<rect x="12" y="38" width="8" height="8" fill="#D9D9D9"/>
			<rect x="20" y="38" width="8" height="8" fill="white"/>
			<rect x="28" y="38" width="8" height="8" fill="#D9D9D9"/>
			<rect x="36" y="38" width="8" height="8" fill="white"/>
		</g>
		<circle cx="22" cy="22" r="21.5" stroke="#CFD3D8"/>
	</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.icon-transparent {
}
</style>